import { post } from 'axios';
import { encodeFormData } from './encode-form-data';

export default {
  sendV1(response) {
    const formattedObject = {
      c_id: response.gaClientID,
      campaign: response.campaign,
      country: response.country,
      deviceType: response.deviceType,
      email: response.emailAddress,
      firstName: response.firstName,
      geo_city: response.Geo_City__c,
      geo_continent: response.Geo_Continent__c,
      geo_country: response.Geo_Country__c,
      geo_latitude: response.Geo_Latitude__c,
      geo_longitude: response.Geo_Longitude__c,
      geo_postal_code: response.Geo_Postal_Code__c,
      geo_state: response.Geo_State__c,
      geo_time_zone: response.Geo_Time_Zone__c,
      keyword: response.keyword,
      landing_page: response.landingpage,
      lastName: response.lastName,
      leadDescription: response.leadDescription,
      leadSource: response.leadSource,
      medium: response.medium,
      optimizely: response.optimizely,
      phoneNumber: response.phoneNumber,
      referrer: response.referrer,
      smsOptIn: response.SMSOptIn,
      source: response.source,
      store_url: response.storeUrl,
      u_id: response.customerId,
      version: response.version
    };

    return this.send(process.env.TRIALS.V1_PARDOT_URL, formattedObject);
  },
  sendV2(response) {
    const formattedObject = {
      c_id: response.gaClientID,
      campaign: response.campaign,
      country: response.country,
      deviceType: response.deviceType,
      email: response.emailAddress,
      firstName: response.firstName,
      geo_city: response.Geo_City__c,
      geo_continent: response.Geo_Continent__c,
      geo_country: response.Geo_Country__c,
      geo_latitude: response.Geo_Latitude__c,
      geo_longitude: response.Geo_Longitude__c,
      geo_postal_code: response.Geo_Postal_Code__c,
      geo_state: response.Geo_State__c,
      geo_time_zone: response.Geo_Time_Zone__c,
      keyword: response.keyword,
      landing_page: response.landingpage,
      lastName: response.lastName,
      leadDescription: response.leadDescription,
      leadSource: response.leadSource,
      medium: response.medium,
      optimizely: response.optimizely,
      phoneNumber: response.phoneNumber,
      referrer: response.referrer,
      smsOptIn: response.SMSOptIn,
      socialSignUp: response.SocialSignUp__c,
      socialSignUpNetwork: response.SocialSignUpNetwork__c,
      source: response.source,
      store_url: response.storeUrl,
      u_id: response.tenantId,
      version: response.version
    };

    return this.send(process.env.TRIALS.V2_PARDOT_URL, formattedObject);
  },
  send(url, payload) {
    return post(url, payload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: '*/*'
      },
      withCredentials: true,
      transformRequest: [encodeFormData]
    });
  }
};
